import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { Modal } from 'Components/Modal'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalFooter } from 'Components/Modal/ModalFooter'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ModalTitle } from 'Components/Modal/ModalTitle'
import SubmitButton from 'Components/Form/SubmitButton'

export class ModalCustom extends PureComponent {
  render() {
    const {
      handleCancel,
      handleConfirm,
      modalShow,
      title,
      text,
      cancelText,
      confirmText,
      children,
      hideCancel,
      hideConfirm,
    } = this.props

    return (
      <Modal show={modalShow} onHide={handleCancel}>
        <ModalHeader closeButton>
          <ModalTitle>{title}</ModalTitle>
        </ModalHeader>
        <ModalBody>
          {text}
          {children}
        </ModalBody>
        <ModalFooter>
          {!hideCancel && (
            <SubmitButton value={cancelText} onClick={handleCancel} />
          )}
          {!hideConfirm && (
            <SubmitButton value={confirmText} onClick={handleConfirm} />
          )}
        </ModalFooter>
      </Modal>
    )
  }
}

ModalCustom.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  modalShow: PropTypes.bool,
  title: PropTypes.string,
  text: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  hideConfirm: PropTypes.bool,
  hideCancel: PropTypes.bool,
}

ModalCustom.defaultProps = {
  title: 'Warning',
  text: 'Are you sure?',
  confirmText: 'Save',
  cancelText: 'Cancel',
}



// WEBPACK FOOTER //
// ./src/Components/Modal/ModalCustom/index.js